import { render, staticRenderFns } from "./KakaoFloatingButton.vue?vue&type=template&id=44484b0a&scoped=true&"
import script from "./KakaoFloatingButton.vue?vue&type=script&lang=js&"
export * from "./KakaoFloatingButton.vue?vue&type=script&lang=js&"
import style0 from "./KakaoFloatingButton.vue?vue&type=style&index=0&id=44484b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44484b0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
